<div class="container">
  <ghs-header [standalone]="true"></ghs-header>

  <div class="menu">
    <label>
      <span [ghs-label]="'settings.edition'"></span>
      <select [(ngModel)]="edition" (change)="update(); updateQueryParams()">
        @for (edition of gameManager.editions(true); track edition) {
        <option [value]="edition">
          <span [ghs-label]="'data.edition.' + edition"></span>
        </option>
        }
      </select>
    </label>
    <label>
      <span [ghs-label]="'game.events.type'"></span>
      <select [(ngModel)]="type" (change)="update(); updateQueryParams()">
        @for (eventType of types; track eventType) {
        <option [value]="eventType">
          <span [ghs-label]="'game.events.type.' + eventType"></span>
        </option>
        }
      </select>
    </label>
    <label>
      <span [ghs-label]="'game.events.select'"></span>
      <select [(ngModel)]="selected" (change)="updateQueryParams()">
        <option [value]="-1">none</option>
        <option [value]="0">flip</option>
        <option [value]="1">A.</option>
        <option [value]="2">B.</option>
        <option [value]="3">C.</option>
      </select>
    </label>
    <button (click)="changeIterator(-1)" [disabled]="iterator == -1">-</button>
    <button (click)="changeIterator(1)">+</button>
    <label>
      <input type="checkbox" [(ngModel)]="spoiler">
      <span [ghs-label]="'game.events.spoiler'"></span>
    </label>
    <label>
      <input type="checkbox" [(ngModel)]="debug">
      <span [ghs-label]="'game.events.debug'"></span>
    </label>
  </div>

  <div class="events">
    @for (event of events | trackUUID; track event._trackUUID) {
    <ghs-event-card [event]="event" [select]="selected != -1 ? selected - 1 : -1" [flipped]="selected == 0"
      [spoiler]="spoiler" [debug]="debug"></ghs-event-card>
    }
  </div>
</div>